// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__18__W","author":"Table_author__25JBX","authorImage":"Table_authorImage__1GSwr","unreadRow":"Table_unreadRow__pB8in"};